module.exports = __webpack_public_path__ + "static/img/shuiji2.f1f01fea.webp";